import type { WorkspaceRole } from '@/lib/permissions/matrix'

export const OPERATIONS_PERMISSION_RESOURCES = {
  claims: 'operationsClaims',
  costs: 'operationsCosts',
  supplies: 'operationsSupplies',
  tags: 'operationsTags',
  templates: 'operationsTemplates',
  verification: 'operationsVerification',
} as const

export type OperationsModule = keyof typeof OPERATIONS_PERMISSION_RESOURCES
export type OperationsPermissionResource =
  (typeof OPERATIONS_PERMISSION_RESOURCES)[OperationsModule]

function readActions(permissions: unknown, resource: string): string[] | undefined {
  if (typeof permissions !== 'object' || permissions === null || Array.isArray(permissions)) {
    return undefined
  }
  const value = Reflect.get(permissions, resource)
  return Array.isArray(value) && value.every((action) => typeof action === 'string')
    ? value
    : undefined
}

export function canViewOperationsModule(
  permissions: unknown,
  module: OperationsModule,
  role: WorkspaceRole
): boolean {
  const explicit = readActions(permissions, OPERATIONS_PERMISSION_RESOURCES[module])
  if (explicit) {
    return explicit.includes('view')
  }

  if (module === 'supplies' || module === 'claims') {
    return readActions(permissions, 'tasks')?.includes('view') === true
  }

  return role === 'ADMIN' || role === 'MANAGER'
}
